import { Component, Input, OnInit } from '@angular/core';

/**
 * StatusPanelComponent
 *
 * @export StatusPanelComponent
 */
@Component({
  selector: 'app-status-panel',
  templateUrl: './status-panel.component.html',
  styleUrls: ['./status-panel.component.scss']
})

export class StatusPanelComponent implements OnInit {

  /**
   * Input panel header
   */
  @Input() statusName = 'Status';

  /**
   * member variable for Input status
   */
  private mStatus: string = null;

  /**
   * Input status setter - updates lastChecked every time this changes
   */
  @Input()
  set status(val) {
    this.mStatus = val;
    this.lastChecked = new Date(Date.now());
  }

  /**
   * status getter
   */
  get status() {
    return this.mStatus;
  }

  /**
   * Input panel content
   */
  @Input() body: Array<string> = [''];

  /**
   * timestamp of last time the status was confirmed
   */
  lastChecked: Date;

  /**
   * Creates an instance of StatusPanelComponent.
   */
  constructor() { }

  /**
   * Does nothing
   */
  ngOnInit() {
  }

}
